import React, { useMemo } from "react";
import { Field, Formik } from "formik";
import { DateInput } from "../FormComponents/DateInput";
import { SimpleMultiSelect } from "../FormComponents/SimpleMultiSelect";
import { SimpleSingleSelect } from "../FormComponents/SimpleSingleSelect";
import "./MyCasesFilters.scss";
import { SingleFilter } from "./SingleFilter";
import { CTA } from "@coverme/forms";

const ProgramStatusFilter = ({ name, value, onChange, disabled }) => {
    let className = "my-cases-filters__status";
    if (disabled === true) {
        className = "my-cases-filters__status disabled";
    }
    return (
        <>
            <p className={className}>Program Status</p>
            <SingleFilter filterStatus="Recommended" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Approved" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Denied" value={value} onChange={onChange} disabled={disabled} />
            <SingleFilter filterStatus="Abandoned" value={value} onChange={onChange} disabled={disabled} />
        </>
    );
};

export const ProgramFilters = ({
    values,
    getErrors,
    getValidationState,
    setFieldValue,
    setTimeout,
    setFieldTouched,
    programs,
    users,
    validationSchema,
    handleSubmit,
    handleReset,
    submitForm,
    onExportClicked,
    setIsProgramForm,
}) => {
    const uniqueProgramsList = useMemo(() => {
        if (programs !== null && programs !== undefined) {
            return [...new Set(programs?.map(x => x.label))];
        }
    }, [programs]);

    const resetFilters = () => {
        values.ProgramStatuses = [];
        values.documentsPrintedEndDate = "";
        values.documentsPrintedStartDate = "";
        values.programEndDate = "";
        values.programStartDate = "";
        values.screeningEndDate = "";
        values.screeningStartDate = "";
    };

    return (
        <>
            <div className="my-cases-filters__bottom">
                <div className="form-section">
                    <div className="my-cases-filters__input">
                        <Field
                            name="programs"
                            render={({ field }) => (
                                <SimpleSingleSelect
                                    name={field.name}
                                    setFieldValue={setFieldValue}
                                    setFieldTouched={setFieldTouched}
                                    id={field.name}
                                    title={"Programs"}
                                    options={uniqueProgramsList?.sort()}
                                    onFieldChange={resetFilters}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                </div>
                <ProgramStatusFilter
                    className="status-filter"
                    setFieldValue={setFieldValue}
                    value={values?.filterProgram?.length > 0 ? ["Recommended"] : values.ProgramStatuses}
                    name="ProgramStatuses"
                    disabled={!values?.programs || values?.programs?.length < 1}
                    onChange={e => {
                        setFieldValue("ProgramStatuses", e);
                    }}
                />
                <div className={`${"open"}`}>
                    <div className="program-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="programStartDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        title={`Recommended Programs Between`}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        disabled={
                                            !values?.programs ||
                                            values?.programs?.length < 1 ||
                                            !(
                                                values?.ProgramStatuses?.length <= 0 ||
                                                values?.ProgramStatuses?.indexOf("Recommended") > -1
                                            )
                                        }
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input program-end-dates">
                            <Field
                                name="programEndDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        disabled={
                                            !values?.programs ||
                                            values?.programs?.length < 1 ||
                                            !(
                                                values?.ProgramStatuses?.length <= 0 ||
                                                values?.ProgramStatuses?.indexOf("Recommended") > -1
                                            )
                                        }
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="program-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="screeningStartDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        title={`Screening Between`}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        disabled={!values?.programs || values?.programs?.length < 1}
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input program-end-dates">
                            <Field
                                name="screeningEndDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        disabled={!values?.programs || values?.programs?.length < 1}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="program-filter-row">
                        <div className="my-cases-filters__input">
                            <Field
                                name="documentsPrintedStartDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        title={`Documents Printed Between`}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        // if no programs are selected disabled = true
                                        // if no filters are selected, disabled = false
                                        // if approved or recommended are selected diabaled = false
                                        disabled={
                                            !values?.programs ||
                                            values?.programs?.length < 1 ||
                                            (!(values?.ProgramStatuses?.length <= 0) &&
                                                !(
                                                    values?.ProgramStatuses?.indexOf("Approved") > -1 ||
                                                    values?.ProgramStatuses?.indexOf("Recommended") > -1
                                                ))
                                        }
                                    />
                                )}
                            />
                        </div>
                        <div className="my-cases-filters__input program-end-dates">
                            <Field
                                name="documentsPrintedEndDate"
                                render={({ field }) => (
                                    <DateInput
                                        {...field}
                                        id={field.name}
                                        changeEvent={e => setFieldValue(field.name, e)}
                                        value={field.value}
                                        errorMessage={getErrors(field)}
                                        validState={getValidationState(field)}
                                        // if no programs are selected disabled = true
                                        // if no filters are selected, disabled = false
                                        // if approved or recommended are selected diabaled = false
                                        disabled={
                                            !values?.programs ||
                                            values?.programs?.length < 1 ||
                                            (!(values?.ProgramStatuses?.length <= 0) &&
                                                !(
                                                    values?.ProgramStatuses?.indexOf("Approved") > -1 ||
                                                    values?.ProgramStatuses?.indexOf("Recommended") > -1
                                                ))
                                        }
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className="program-filter-row">
                        {users.length >= 1 && (
                            <div
                                className={
                                    !values?.programs || values?.programs?.length < 1
                                        ? "my-cases-filters__input disabled"
                                        : "my-cases-filters__input"
                                }
                            >
                                <Field
                                    name="creatorUsers"
                                    render={({ field }) => (
                                        <SimpleMultiSelect
                                            name={field.name}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            id={field.name}
                                            title={"Users"}
                                            options={users}
                                            disabled={!values?.programs || values?.programs?.length < 1}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="program-filter-buttons">
                    <div className="my-cases-filters__submit">
                        <button
                            className="reset_button"
                            type="reset"
                            onClick={() => {
                                handleReset();
                                handleSubmit();
                            }}
                        >
                            Reset All
                        </button>
                    </div>
                    <div className="my-cases-filters__submit">
                        <CTA
                            size={"medium"}
                            styleType={"blue"}
                            click={() => {
                                handleSubmit(values);
                            }}
                            disabled={!values?.programs || values?.programs?.length < 1}
                        >
                            Submit
                        </CTA>
                    </div>
                    <div className="my-cases-filters__submit">
                        <CTA
                            size={"medium"}
                            styleType={"blue"}
                            click={onExportClicked.bind(this, values)}
                            disabled={!values?.programs || values?.programs?.length < 1}
                        >
                            Export
                        </CTA>
                    </div>
                </div>
            </div>
        </>
    );
};
